import { Select } from "antd";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const ModelSelectOption = ({ option: { id, name }, fieldName }) => {
  return (
    <Option data-testid={`select-option-${fieldName}`} key={id} value={id}>
      {name}
    </Option>
  );
};

export default ModelSelectOption;
